import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Aboutcard from "./AboutCard";
import Techstack from "./Techstack";
import Toolstack from "./Toolstack";
import Github from "./Github";
import ScrollReveal from "../ScrollReveal/ScrollReveal";
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import "./about.css";

const principles = [
  "TypeScript, Node.js, NestJS",
  "Webhook reliability and idempotency",
  "Secure APIs and auth patterns",
  "PostgreSQL and MySQL design",
];

const backendFocus = [
  "Secure REST APIs and modular NestJS services",
  "Webhook flows with retries, idempotency, and auditing",
  "PostgreSQL and MySQL schema design for production systems",
  "End-to-end ownership from requirements to production support",
];

function About() {
  return (
    <Container fluid className="about-section">
      <Container className="section-shell">
        <ScrollReveal as="section" className="about-hero" distance={28}>
          <Row className="align-items-center section-gap">
            <Col lg={6}>
              <div className="section-intro">
                <span className="section-kicker">About</span>
                <h1>Backend systems, integrations, and delivery leadership.</h1>
                <p className="section-copy">
                  I specialize in backend engineering with strong experience in
                  modular service design, secure APIs, relational databases, and
                  production support across high-usage mobile and web products.
                </p>
              </div>
              <div className="principles-list">
                {principles.map((item) => (
                  <div className="principle-pill" key={item}>
                    {item}
                  </div>
                ))}
              </div>
            </Col>
            <Col lg={6} className="about-art">
              <div className="about-art-card">
                <span className="section-kicker">Backend Focus</span>
                <h2>What I usually own on a project.</h2>
                <div className="about-focus-list">
                  {backendFocus.map((item) => (
                    <div className="about-focus-item" key={item}>
                      {item}
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </ScrollReveal>

        <ScrollReveal as="section" className="about-story" delay={70} distance={24}>
          <Row className="section-gap align-items-start">
            <Col lg={7}>
              <Aboutcard />
            </Col>
            <Col lg={5}>
              <div className="about-side-card">
                <span className="section-kicker">Education</span>
                <h2>Bachelor of Software Engineering</h2>
                <p>
                  School Of Engineering, Pokhara University, Pokhara.
                </p>
                <p>
                  References available upon request.
                </p>
              </div>
            </Col>
          </Row>
        </ScrollReveal>

        <ScrollReveal as="section" className="stack-section" delay={90} distance={22}>
          <div className="section-intro compact">
            <span className="section-kicker">Stack</span>
            <h2>Technologies I use in delivery.</h2>
          </div>
          <Techstack />
        </ScrollReveal>

        <ScrollReveal as="section" className="stack-section" delay={110} distance={22}>
          <div className="section-intro compact">
            <span className="section-kicker">Tooling</span>
            <h2>Tools I rely on in daily work.</h2>
          </div>
          <Toolstack />
        </ScrollReveal>

        <ScrollReveal as="section" className="github-section" delay={130} distance={22}>
          <Github />
        </ScrollReveal>
      </Container>
      <ScrollToTop />
    </Container>
  );
}

export default About;
